import DOMPurify from "dompurify";

// El contrato se presenta como HTML; solo se permiten elementos de formato y enlaces.
export const sanitizarContratoHtml = (html) => {
  if (!DOMPurify.isSupported) return "";
  return DOMPurify.sanitize(String(html || ""), {
    ALLOWED_TAGS: ["div", "span", "p", "br", "h1", "h2", "h3", "h4", "h5", "h6", "b", "strong", "em", "i", "u", "ul", "ol", "li", "table", "thead", "tbody", "tfoot", "tr", "td", "th", "blockquote", "hr", "a"],
    ALLOWED_ATTR: ["class", "href", "title", "colspan", "rowspan"],
    ALLOW_DATA_ATTR: false,
  });
};
